import { Entidad } from "../../../data/Entidad";
import { Fields, FormGenerator, IField } from "../../controlD3/Formulario";
import { UIUtilPermission } from "../../util/Permission";
import { UIUtilViewData } from "../../util/ViewData";
import { UIUtilViewFinanzaCargo } from "./FinanzaCargo";

import CTipoValor = Entidad.CFinanzaCargoTipoValor;
import IFinanzaCargo = Entidad.IFinanzaCargo;
import CAccionPermiso = Entidad.CAccionPermiso;

const MODULO = Entidad.CModulo.FinanzasCargo;

enum CFormModels {
    Nombre = "Nombre",
    TipoValor = "TipoValor",
    Valor = "Valor",
    Periodicidad = "Periodicidad",
    Escuela = "IdEscuela",
    TipoRecargo = "TipoRecargo",
    TipoInteres = "TipoInteres",
    ValorRecargo = "ValorRecargo"
}

export function GetFinanzaDescuentoForm(action: (CAccionPermiso.AgregarDescuentos | CAccionPermiso.Editar), descuento: IFinanzaCargo) {
    let esEditar = (action == CAccionPermiso.Editar);
    let escuelasConPermiso = UIUtilPermission._GetSchoolsByActionModule(MODULO, action, descuento.IdEscuela);
    //let escuelasConPermiso = Util.Permission.fn_GetSchoolsByActionModule(Entidad.CModulo.FinanzasCargo, action, descuento.IdEscuela);
    let form = new FormGenerator<IFinanzaCargo>();
    let formSchema: Array<IField<IFinanzaCargo>> = [
        {
            model: CFormModels.Nombre,
            type: Fields.input,
            inputAttr: { type: "text", disabled: false, removeBorder: false, required: true },
            labelAttr: { text: "frm1_nombre" },
        },
        {
            model: CFormModels.TipoValor,
            type: Fields.radioList,
            labelAttr: { text: "frm1_tipovalor" },
            radioListAttr: {
                ValueMember: "Id",
                DisplayMember: "Name",
                ReturnOnlyValueMember: true,
                Data: UIUtilViewData._GetList_TipoValor(),
                required: true,
                OnChange: (data: UIUtilViewData.IBaseData) => {
                    UIUtilViewFinanzaCargo._ApplyTypeValueToInputValue(data.Id, "valorCargo", form);
                }
            }
        },
        {
            model: CFormModels.Valor,
            type: Fields.input,
            inputAttr: { type: "number", min: 0, required: true },
            labelAttr: { text: "frm1_valor" }
        },
        {
            model: CFormModels.Escuela,
            type: Fields.selectMaterial,
            labelAttr: { text: "frm1_esc" },
            selectMaterialAttr: { valueMember: "IdKinder", displayMember: "Nombre", disabled: esEditar, removeBorder: esEditar, required: true },
            values: escuelasConPermiso
        }
    ];

    let validaValor = (valor: number, tipoValor: CTipoValor) => {
        if (tipoValor == CTipoValor.Porcentaje) {
            return valor > 0 && valor <= 100;
        }
        else if (tipoValor == CTipoValor.Monto) {
            return valor > 0;
        } else {
            return false;
        }
    }

    form._Crear({
        LangModuleKeyInContext: "finanzascargo",
        schema: formSchema,
        LabelMaxWidth: 100,
        Validation: (value, field, dataForm, controlsForm) => {
            let isValid = true;

            if (field == "Valor") {
                let strDecims = dataForm["Valor"].toString().split(".")[1];
                if (strDecims) isValid = !(strDecims.length > 2);

                if (isValid) {
                    dataForm.Valor = Number(dataForm.Valor);
                    isValid = validaValor(dataForm.Valor, form._Data.TipoValor);
                }
            }
            return isValid;
        },
    }, descuento);
    UIUtilViewFinanzaCargo._ApplyTypeValueToInputValue(descuento.TipoValor, "valorCargo", form);

    return form;
}